module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "main situation"
  }, [(_vm.crumbList && _vm.crumbList.length) ? _c('div', {
    staticClass: "crumb"
  }, [_vm._l((_vm.crumbList), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "crumb_item",
      on: {
        "click": _vm.closeMask
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "order_list",
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.myAccidentList), function(item, index) {
    return _c('span', {
      key: ('accidentList_' + index),
      staticClass: "crumb_item bg_eee",
      class: {
        activeCrumb: item.recordNo == _vm.baseInfo.recordNo
      },
      on: {
        "click": function($event) {
          return _vm.reStartMask(item.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.recordNo) + "\n\t\t\t\t\t"), _c('img', {
      staticClass: "close_img",
      attrs: {
        "src": require("../../assets/images/icon/home_tab_icon_close.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.doCancel(item.id, index)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "jumpBtn"
  }, [_c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(0)
      }
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(1)
      }
    }
  }, [_vm._v("证据照片")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(2)
      }
    }
  }, [_vm._v("人员信息")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(3)
      }
    }
  }, [_vm._v("车辆信息")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(4)
      }
    }
  }, [_vm._v("违法信息")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(5)
      }
    }
  }, [_vm._v("询问笔记")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(6)
      }
    }
  }, [_vm._v("返回凭证")])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "leftContent input_new_style",
    class: [_vm.fullVideo ? 'fullVideoClass_left' : 'original_left']
  }, [_c('el-collapse', {
    model: {
      value: (_vm.activeName_a),
      callback: function($$v) {
        _vm.activeName_a = $$v
      },
      expression: "activeName_a"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "基本信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("违法处理地点")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "organizationId", $$v)
      },
      expression: "baseInfo.organizationId"
    }
  }, _vm._l((_vm.daduiLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xwdd"),
      attrs: {
        "label": item.fullName,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("违法处理单位")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.handleOrganizationId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "handleOrganizationId", $$v)
      },
      expression: "baseInfo.handleOrganizationId"
    }
  }, _vm._l((_vm.daduiLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_gzdw"),
      attrs: {
        "label": item.fullName,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("经办人1")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.firstOperatorId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "firstOperatorId", $$v)
      },
      expression: "baseInfo.firstOperatorId"
    }
  }, _vm._l((_vm.userLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xwr1"),
      attrs: {
        "label": item.realname,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("经办人2")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.secondOperatorId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "secondOperatorId", $$v)
      },
      expression: "baseInfo.secondOperatorId"
    }
  }, _vm._l((_vm.userLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xwr2"),
      attrs: {
        "label": item.realname,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("违法处理时间")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "disabled": _vm.disabled_edit,
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.baseInfo.handleTime),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "handleTime", $$v)
      },
      expression: "baseInfo.handleTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("预约地点")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.baseInfo.location),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "location", $$v)
      },
      expression: "baseInfo.location"
    }
  }), _vm._v(" "), (!_vm.disabled_edit) ? _c('span', {
    staticClass: "case_address",
    on: {
      "click": function($event) {
        return _vm.showMap(1)
      }
    }
  }, [_c('i', {
    staticClass: "icon_address"
  })]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("违法时间")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "disabled": _vm.disabled_edit,
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.baseInfo.accidentTime),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "accidentTime", $$v)
      },
      expression: "baseInfo.accidentTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("违法地点")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.baseInfo.accidentAddress),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "accidentAddress", $$v)
      },
      expression: "baseInfo.accidentAddress"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("道路代码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "48%",
      "margin-right": "2%"
    },
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit,
      "fetch-suggestions": (function (e, cb) {
        _vm.getRoadCode(e, cb, 1)
      })
    },
    on: {
      "select": function($event) {
        return _vm.handleSelect($event, 1)
      }
    },
    model: {
      value: (_vm.baseInfo.firstRoadInfo),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "firstRoadInfo", $$v)
      },
      expression: "baseInfo.firstRoadInfo"
    }
  }), _vm._v(" "), _c('el-autocomplete', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit,
      "fetch-suggestions": (function (e, cb) {
        _vm.getRoadCode(e, cb, 2)
      })
    },
    on: {
      "select": function($event) {
        return _vm.handleSelect($event, 2)
      }
    },
    model: {
      value: (_vm.baseInfo.secondRoadInfo),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "secondRoadInfo", $$v)
      },
      expression: "baseInfo.secondRoadInfo"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("违法代码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-autocomplete', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit,
      "fetch-suggestions": (function (e, cb) {
        _vm.getRoadCode(e, cb, 3)
      })
    },
    on: {
      "select": function($event) {
        return _vm.handleSelect($event, 3)
      }
    },
    model: {
      value: (_vm.autocomplete_value),
      callback: function($$v) {
        _vm.autocomplete_value = $$v
      },
      expression: "autocomplete_value"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("案件类型")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_vm._v("一般程序")])])])])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeName_g),
      callback: function($$v) {
        _vm.activeName_g = $$v
      },
      expression: "activeName_g"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "证据照片",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "retrun_case"
  }, [_vm._l((_vm.evidences), function(item, index) {
    return [(item.indexOf('.mp4') == -1) ? _c('img', {
      key: index,
      staticClass: "retrun_image",
      attrs: {
        "src": _vm.getImageUrl(item) + '&time=' + new Date().getTime()
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item)
        }
      }
    }) : _c('img', {
      key: index,
      staticClass: "retrun_image",
      attrs: {
        "src": require("../../assets/images/pics/player.png")
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item)
        }
      }
    })]
  })], 2)])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeName_b),
      callback: function($$v) {
        _vm.activeName_b = $$v
      },
      expression: "activeName_b"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "人员信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("姓名")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.realName),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "realName", $$v)
      },
      expression: "userInfos.realName"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("性别")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.sex),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "sex", $$v)
      },
      expression: "userInfos.sex"
    }
  }, _vm._l((_vm.sexTypeLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xb"),
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("联系方式")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.phone),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "phone", $$v)
      },
      expression: "userInfos.phone"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("驾驶证/身份证号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.idCardNo),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "idCardNo", $$v)
      },
      expression: "userInfos.idCardNo"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("现住详细地址")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.address),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "address", $$v)
      },
      expression: "userInfos.address"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("准驾车型")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "multiple": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.moreCarClass),
      callback: function($$v) {
        _vm.moreCarClass = $$v
      },
      expression: "moreCarClass"
    }
  }, _vm._l((_vm.tempList.driList), function(item) {
    return _c('el-option', {
      key: item.CODE,
      attrs: {
        "label": item.CODE,
        "value": ("" + (item.id))
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("驾驶证档案编号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.archivesCode),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "archivesCode", $$v)
      },
      expression: "userInfos.archivesCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("发证机构")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.issuingAuthority),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "issuingAuthority", $$v)
      },
      expression: "userInfos.issuingAuthority"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("证件地址")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.cardAddress),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "cardAddress", $$v)
      },
      expression: "userInfos.cardAddress"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("工作单位")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.workCompany),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "workCompany", $$v)
      },
      expression: "userInfos.workCompany"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("法定代表人")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.legalLeader),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "legalLeader", $$v)
      },
      expression: "userInfos.legalLeader"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("出生日期")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.birthday),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "birthday", $$v)
      },
      expression: "userInfos.birthday"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("文化程度")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.educationLevel),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "educationLevel", $$v)
      },
      expression: "userInfos.educationLevel"
    }
  }, _vm._l((_vm.tempList.knowledgeLists), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("职业")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.job),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "job", $$v)
      },
      expression: "userInfos.job"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("政治面貌")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.politicalOutlook),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "politicalOutlook", $$v)
      },
      expression: "userInfos.politicalOutlook"
    }
  }, _vm._l((_vm.tempList.politicalLists), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("交通方式")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.transportWay),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "transportWay", $$v)
      },
      expression: "userInfos.transportWay"
    }
  }, _vm._l((_vm.tempList.meaList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeName_h),
      callback: function($$v) {
        _vm.activeName_h = $$v
      },
      expression: "activeName_h"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "车辆信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("车牌号码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px",
      "margin-right": "10px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.car_title),
      callback: function($$v) {
        _vm.car_title = $$v
      },
      expression: "car_title"
    }
  }, _vm._l((_vm.tempList.liceList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.car_number),
      callback: function($$v) {
        _vm.car_number = $$v
      },
      expression: "car_number"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("号牌种类")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.plateTypeId),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "plateTypeId", $$v)
      },
      expression: "userInfos.plateTypeId"
    }
  }, _vm._l((_vm.tempList.flaList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("车辆类型")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.vehicleTypeId),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "vehicleTypeId", $$v)
      },
      expression: "userInfos.vehicleTypeId"
    }
  }, _vm._l((_vm.tempList.vehList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeName_i),
      callback: function($$v) {
        _vm.activeName_i = $$v
      },
      expression: "activeName_i"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "违法信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("文书编号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.note.fileNo),
      callback: function($$v) {
        _vm.$set(_vm.note, "fileNo", $$v)
      },
      expression: "note.fileNo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("罚款金额")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "number",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.price),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "price", $$v)
      },
      expression: "userInfos.price"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("通知书文书编号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.note.notificationProcessBookNo),
      callback: function($$v) {
        _vm.$set(_vm.note, "notificationProcessBookNo", $$v)
      },
      expression: "note.notificationProcessBookNo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeName_c),
      callback: function($$v) {
        _vm.activeName_c = $$v
      },
      expression: "activeName_c"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "询问笔记",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("询问次数")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "number",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.note.askTimes),
      callback: function($$v) {
        _vm.$set(_vm.note, "askTimes", $$v)
      },
      expression: "note.askTimes"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("模版类型")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": _vm.selectTemplate
    },
    model: {
      value: (_vm.note.templateName),
      callback: function($$v) {
        _vm.$set(_vm.note, "templateName", $$v)
      },
      expression: "note.templateName"
    }
  }, _vm._l((_vm.templateArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("传唤时间")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "disabled": _vm.disabled_edit,
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.note.callingTime),
      callback: function($$v) {
        _vm.$set(_vm.note, "callingTime", $$v)
      },
      expression: "note.callingTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("结束时间")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "disabled": _vm.disabled_edit,
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.note.endTime),
      callback: function($$v) {
        _vm.$set(_vm.note, "endTime", $$v)
      },
      expression: "note.endTime"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("出发地")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.note.startAddress),
      callback: function($$v) {
        _vm.$set(_vm.note, "startAddress", $$v)
      },
      expression: "note.startAddress"
    }
  }), _vm._v(" "), (!_vm.disabled_edit) ? _c('span', {
    staticClass: "case_address",
    on: {
      "click": function($event) {
        return _vm.showMap(2)
      }
    }
  }, [_c('i', {
    staticClass: "icon_address"
  })]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("目的地")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.note.endAddress),
      callback: function($$v) {
        _vm.$set(_vm.note, "endAddress", $$v)
      },
      expression: "note.endAddress"
    }
  }), _vm._v(" "), (!_vm.disabled_edit) ? _c('span', {
    staticClass: "case_address",
    on: {
      "click": function($event) {
        return _vm.showMap(3)
      }
    }
  }, [_c('i', {
    staticClass: "icon_address"
  })]) : _vm._e()], 1)])])]), _vm._v(" "), _vm._l((_vm.transcripts), function(item, index) {
    return _c('div', {
      key: (index + "_xwbj"),
      staticClass: "big_case"
    }, [(item.operateType != 'REMOVE') ? [_c('ul', {
      staticClass: "ul_case"
    }, [_c('li', [_c('span', [_vm._v("问：")]), _c('el-input', {
      staticClass: "my_input",
      attrs: {
        "placeholder": "请输入",
        "type": "textarea",
        "rows": 3,
        "disabled": _vm.disabled_edit
      },
      on: {
        "change": function($event) {
          return _vm.onChengeQ(index)
        }
      },
      model: {
        value: (item.question),
        callback: function($$v) {
          _vm.$set(item, "question", $$v)
        },
        expression: "item.question"
      }
    })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("答：")]), _c('el-input', {
      attrs: {
        "placeholder": "请输入",
        "type": "textarea",
        "rows": 2,
        "disabled": _vm.disabled_edit
      },
      on: {
        "change": function($event) {
          return _vm.onChengeQ(index)
        }
      },
      model: {
        value: (item.answer),
        callback: function($$v) {
          _vm.$set(item, "answer", $$v)
        },
        expression: "item.answer"
      }
    })], 1)]), _vm._v(" "), (!_vm.disabled_edit) ? _c('ul', {
      staticClass: "ul_contor"
    }, [_c('li', [_c('i', {
      staticClass: "el-icon-refresh",
      on: {
        "click": function($event) {
          return _vm.onCutQ(index)
        }
      }
    })]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "el-icon-plus",
      on: {
        "click": function($event) {
          return _vm.onAddQ(index)
        }
      }
    })]), _vm._v(" "), _c('li', [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          return _vm.onDeletaQ(index, item)
        }
      }
    })])]) : _vm._e()] : _vm._e()], 2)
  })], 2)])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeName_f),
      callback: function($$v) {
        _vm.activeName_f = $$v
      },
      expression: "activeName_f"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "返回凭证",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "retrun_case"
  }, [(_vm.notificationImage) ? [_c('img', {
    staticClass: "retrun_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.notificationImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.notificationImage, 'type2')
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.notificationRecordImage) ? [_c('img', {
    staticClass: "retrun_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.notificationRecordImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.notificationRecordImage, 'type2')
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.commitImage) ? [_c('img', {
    staticClass: "retrun_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.commitImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.commitImage, 'type2')
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.askRecordImage) ? _vm._l((_vm.askRecordImage.split(',')), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "retrun_image",
      attrs: {
        "src": _vm.getImageUrl(item) + '&time=' + new Date().getTime()
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item, 'type2')
        }
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.notificationProcessImage) ? [_c('img', {
    staticClass: "retrun_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.notificationProcessImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.notificationProcessImage, 'type2')
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.normalPenaltiesImage) ? [_c('img', {
    staticClass: "retrun_image",
    staticStyle: {
      "background": "#f8f8f8"
    },
    attrs: {
      "src": _vm.getImageUrl(_vm.normalPenaltiesImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.normalPenaltiesImage, 'type2')
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.firstWenshuImage) ? [_c('img', {
    staticClass: "retrun_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.firstWenshuImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.firstWenshuImage, 'type2')
      }
    }
  })] : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "66px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.normalPenaltiesImage) ? [_c('div', {
    ref: "print"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.getImageUrl(_vm.normalPenaltiesImage) + '&time=' + new Date().getTime()
    }
  })])] : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightContent",
    class: {
      fullVideoClass_right: _vm.fullVideo
    }
  }, [(_vm.trtcStatus) ? _c('div', {
    staticClass: "left no_video_text"
  }, [(!_vm.disabled_edit) ? _c('span', [(_vm.remoteStatus == 'success' && !_vm.hasLocal) ? _c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "success"
    }
  }, [_vm._v("用户在线")]) : _vm._e(), _vm._v(" "), (_vm.remoteStatus == 'danger' && !_vm.list.length) ? _c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("用户离线")]) : _vm._e()], 1) : _vm._e()]) : _c('div', {
    staticClass: "left"
  }, [(_vm.videoBtnShow) ? _c('div', {
    staticClass: "videoBtnZone"
  }, [(!_vm.disabled_edit) ? _c('span', {
    attrs: {
      "id": "myBtnCase2"
    }
  }, [(_vm.remoteStatus == 'success' && !_vm.hasLocal) ? _c('el-button', {
    directives: [{
      name: "preventReClick",
      rawName: "v-preventReClick",
      value: (5000),
      expression: "5000"
    }],
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.getRoom
    }
  }, [_vm._v("视频呼叫")]) : _vm._e(), _vm._v(" "), (_vm.remoteStatus == 'danger' && !_vm.list.length) ? _c('el-button', {
    directives: [{
      name: "preventReClick",
      rawName: "v-preventReClick",
      value: (5000),
      expression: "5000"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.notInRoom
    }
  }, [_vm._v("视频呼叫")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoState == 0),
      expression: "videoState == 0"
    }],
    staticClass: "display-flex-between—new",
    staticStyle: {
      "margin-top": "478px"
    }
  }, [(_vm.localStream) ? _c('div', {
    staticClass: "userlist local",
    class: [_vm.myTempIndex === null ? _vm.myMainVideo : ''],
    attrs: {
      "id": "warp myLocal"
    },
    on: {
      "click": function($event) {
        return _vm.switchLocalMain1($event)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "local_stream"
    }
  }, [(_vm.list.length) ? _c('div', {
    staticClass: "role1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.muteLocalAudio.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "policeMuteClass",
    attrs: {
      "src": _vm.isAudio ? require('../../assets/images/pics/icon_microphone2_sel.png') : require('../../assets/images/pics/icon_microphone2_nor.png')
    }
  }), _vm._v(" "), _c('span', [_vm._v("交警")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isVedio),
      expression: "!isVedio"
    }],
    staticClass: "maskable",
    attrs: {
      "id": "mask"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.list.length && _vm.showPolice) ? _c('div', {
    staticClass: "userlist bg-white remote police",
    attrs: {
      "id": "warp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t交警\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "userlist remoteClass remote user",
      class: [_vm.myTempIndex === index ? _vm.myMainVideo : '']
    }, [(item.remoteStream) ? _c('div', {
      staticClass: "distant-stream",
      attrs: {
        "id": item.id
      },
      domProps: {
        "innerHTML": _vm._s(item.remoteStream)
      }
    }) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "display-flex margin-top-15"
  }, [(!_vm.videoBtnShow) ? _c('div', {
    staticClass: "myBtn",
    on: {
      "click": _vm.leaveRoom
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pics/icon_hang_up.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("挂断")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottomBtns"
  }, [(!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-tickets"
    },
    on: {
      "click": _vm.onImportNotes
    }
  }, [_vm._v("导入笔记")]) : _vm._e(), _vm._v(" "), (_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadProcessFile
    }
  }, [_vm._v("一键打包下载")]) : _vm._e(), _vm._v(" "), (_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.seeProcessFile
    }
  }, [_vm._v("查看过程文件")]) : _vm._e(), _vm._v(" "), (_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.seeSignBook
    }
  }, [_vm._v("查看文书")]) : _vm._e(), _vm._v(" "), (_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showVideos
    }
  }, [_vm._v("查看视频")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendProcessFile
    }
  }, [_vm._v("推送过程文件")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendSignBook
    }
  }, [_vm._v("推送文书")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.printSignBook
    }
  }, [_vm._v("打印文书")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.stopHandle
    }
  }, [_vm._v("处置终止")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.onFinish
    }
  }, [_vm._v("全流程完成")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.closeMask
    }
  }, [_vm._v("返回")]), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    staticStyle: {
      "margin-left": "100px"
    },
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.onSendImages
    }
  }, [_vm._v("重发三证短信")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.onSendMessage
    }
  }, [_vm._v("重发用户短信")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onFirstWS
    }
  }, [_vm._v("首违文书推送")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "80%",
      "title": "询问笔记问题",
      "center": "",
      "visible": _vm.dialog_state,
      "close-on-click-modal": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_state = $event
      }
    }
  }, _vm._l((_vm.questions), function(item, index) {
    return _c('div', {
      key: (index + "_xwbj"),
      staticClass: "big_case"
    }, [_c('ul', {
      staticClass: "ul_case"
    }, [_c('li', [_c('span', [_vm._v("问：")]), _c('el-input', {
      staticClass: "my_input",
      attrs: {
        "disabled": "",
        "placeholder": "请输入",
        "type": "textarea",
        "rows": 2
      },
      model: {
        value: (item.question),
        callback: function($$v) {
          _vm.$set(item, "question", $$v)
        },
        expression: "item.question"
      }
    })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("答：")]), _c('el-input', {
      attrs: {
        "disabled": "",
        "placeholder": "请输入",
        "type": "textarea",
        "rows": 1
      },
      model: {
        value: (item.answer),
        callback: function($$v) {
          _vm.$set(item, "answer", $$v)
        },
        expression: "item.answer"
      }
    })], 1)]), _vm._v(" "), _c('ul', {
      staticClass: "ul_contor"
    }, [_c('li', {
      staticClass: "ul_li_btn",
      on: {
        "click": function($event) {
          return _vm.onSelectQ(index, item)
        }
      }
    }, [_vm._v("选择")])])])
  }), 0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.map_state) ? _c('MapMask', {
    attrs: {
      "lng": _vm.lng,
      "lat": _vm.lat,
      "mapIndex": _vm.mapIndex
    },
    on: {
      "hideMap": _vm.hideMap
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.videos_state) ? _c('Videos', {
    attrs: {
      "videosId": _vm.roomId
    },
    on: {
      "hideVideos": _vm.hideVideos
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-564c5ce6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/weifa/video.vue
// module id = VfmC
// module chunks = 6